module.exports = __webpack_public_path__ + "static/media/oval.be00fc4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/system/assets/images/oval.svg
// module id = 483
// module chunks = 0